import axios from 'axios';
import { API_url } from '../api.setup';
import { enqueueSnackbar } from 'notistack';
import { SubscriptionStatus } from 'src/models/subscription/subscriptionModel';

const API_Controller = '/Subscriptions';

const SubscriptionServices = {
  getSubscriptionForCityByDate: async (cityId, startDate, endDate) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getSubscriptionsForCityByDateRange?cityId=${cityId}&startDate=${startDate}&endDate=${endDate} `
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  getSubscriptionForCityByStatus: async (cityId: number, statuses: number[]) => {
    try {
      const queryString = `cityId=${cityId}&${statuses.map(s => `statuses=${s}`).join('&')}`;
      const response = await axios.get(
        `${API_url}${API_Controller}/getSubscriptionsForCityByStatus?${queryString}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSubscriptionHistory: async (subscriptionId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/GetSubscriptionHistory?subscriptionId=${subscriptionId}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  renewSubscription: async (subscriptionId, newData) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/renewSubscription?subscriptionId=${subscriptionId}`,
        newData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  updateSubscriptionCustomerCar: async (subscriptionId, customerCarId) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/updateCustomerCar?subscriptionId=${subscriptionId}&customerCarId=${customerCarId}`
      );
      enqueueSnackbar(`Subscription Car Updated Successfully`, {
        variant: 'success'
      });
      return response.data;
    } catch (error) {
      enqueueSnackbar(`Subscription Updated Unsuccessfully`, {
        variant: 'error'
      });
      console.error(error);
      throw error;
    }
  },
  updateSubscriptionPreferredTimeSlot: async (subscriptionId, preferredTimeSlotId) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/updatePreferredTimeSlot?subscriptionId=${subscriptionId}&preferredTimeSlotId=${preferredTimeSlotId}`
      );
      enqueueSnackbar(`Preferred Time Slot Updated Successfully`, {
        variant: 'success'
      });
      return response.data;
    } catch (error) {
      enqueueSnackbar(`Preferred Time Slot Update Failed`, {
        variant: 'error'
      });
      console.error(error);
      throw error;
    }
  },

  updateSubscriptionCustomerAddress: async (
    subscriptionId,
    customerAddressId
  ) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/updateAddress?subscriptionId=${subscriptionId}&customerAddressId=${customerAddressId}`
      );
      enqueueSnackbar(`Subscription Address Updated Successfully`, {
        variant: 'success'
      });
      return response.data;
    } catch (error) {
      enqueueSnackbar(`Subscription Updated Unsuccessfully`, {
        variant: 'error'
      });
      console.error(error);
      throw error;
    }
  },

  subscriptionOnHold: async (newData) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/SubscriptionOnHoldRequest`,
        newData
      );


      enqueueSnackbar(`Subscription Holded Successfully`, {
        variant: 'success'
      });


      return response.data;
    } catch (error) {

      enqueueSnackbar(`Cannot hold subscription out of subscription duration`, {
        variant: 'error'
      });

      throw error;
    }
  },

  addSubscriptionPaymentDetails: async (paymentData) => {
    try {
      const response = await axios.post(
        `${API_url}${API_Controller}/AddSubscriptionPaymentDetails`,
        paymentData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSubscriptionPaymentsDetails: async (SubId) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/GetSubscriptionPaymentDetails?subscriptionId=${SubId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getAllSubscriptionStatus: async () => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/getAllSubscriptionStatus`);
      return response.data as SubscriptionStatus[];
    } catch (error) {
      throw error;
    }
  },

  addSubscriptionNote: async (noteData) => {
    try {
      return await axios.post(`${API_url}${API_Controller}/CreateSubscriptionNotes`, noteData);
    } catch (error) {
      enqueueSnackbar('Failed to add subscription note', { variant: 'error' });
      throw error;
    }
  },
  getAllSubscriptionNotesBySubscriptionId: async (subscriptionId: number) => {
    try {
      const response = await axios.get(`${API_url}${API_Controller}/getAllSubscriptionNotesBySubscriptionId`, {
        params: { subscriptionId },
      });
      return response.data.notes;
    } catch (error) {
      console.error('Failed to fetch subscription notes:', error);
      throw error;
    }
  },

  getSubscriptionOnHoldBySubscriptionId: async (subscriptionId) => {
    try {
      const response = await axios.get(
        `${API_url}${API_Controller}/SubscriptionOnHold?subscriptionId=${subscriptionId}`,
      );
      return response.data;
    } catch (error) {
      console.error('Failed to fetch subscription on-hold data:', error);
      throw error;
    }
  },

  updateSubscriptionStatus: async (subscriptionId, status) => {

    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/updateSubscriptionStatus?subscriptionId=${subscriptionId}&status=${status}`,
      );
      return response.data;
    } catch (error) {
      console.error('Error updating subscription status:', error);
      throw error;
    }
  },

  extendSubscription: async (subscriptionId: number, data: { newEndDate: string, note: string }) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/extendSubscription?subscriptionId=${subscriptionId}`,
        data
      );

      return response.data;
    } catch (error: any) {
      console.error('Error extending subscription:', error);
      throw error;
    }
  },
  editSubscriptionOnHoldById: async (newData: any) => {
    try {
      const response = await axios.put(
        `${API_url}${API_Controller}/editSubscriptionOnHoldRequest`, newData
      );
      return response.data;
    } catch (error) {
      console.error('Failed to fetch subscription on-hold data:', error);
      throw error;
    }
  },

};

export default SubscriptionServices;
